import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@material-ui/core';

import useFetch from 'src/hooks/useFetch';

import { Centered } from 'src/components/Centered';
import { ConfirmButton } from 'src/components/ConfirmButton';

import { Container, Title, CardBox, CardTitle } from './styles';
import CarBrand from '../../components/CardBrand';
import { useState } from 'react';

function ChooseDefaultCardShow({ userId, onFinish }) {
  const [defaultCartaoData, isDefaultCartaoLoading] = useFetch(
    `/cartaoCredito?id=${userId}`
  );

  const [hideChoose, setHideChoose] = useState(false);

  const handlePressOptions = (useDefaultCard = false) => {
    if (useDefaultCard && defaultCartaoData?.data) {
      onFinish({
        idPagamento: defaultCartaoData.id,
        ...defaultCartaoData.data,
      });
    } else {
      onFinish();
    }

    setHideChoose(true);
  };

  if (isDefaultCartaoLoading) {
    return (
      <Centered>
        <CircularProgress color="primary" size={40} />
      </Centered>
    );
  }

  if (defaultCartaoData === null || hideChoose) {
    onFinish?.();

    return null;
  }

  return (
    <Container>
      <Title>Deseja utilizar o cartão padrão:</Title>
      <CardBox>
        <CarBrand
          cardNumber={defaultCartaoData?.data?.display_number}
          defaultBrand={defaultCartaoData?.data?.brand}
        />
        <CardTitle>{defaultCartaoData?.data?.display_number}</CardTitle>
      </CardBox>
      <Box display="flex" flexDirection="row">
        <ConfirmButton
          type="button"
          variant="contained"
          onClick={() => handlePressOptions(true)}
        >
          Sim
        </ConfirmButton>
        <ConfirmButton
          type="button"
          variant="contained"
          onClick={() => handlePressOptions(false)}
        >
          Não
        </ConfirmButton>
      </Box>
    </Container>
  );
}

ChooseDefaultCardShow.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onFinish: PropTypes.func,
};

export default ChooseDefaultCardShow;
